import { i18nToTypesenseMainIndex } from '~~/helpers/locales/i18nCurrentDetails';
import { getCurrentFiltersCount } from '~~/helpers/typesense/getCurrentFiltersCount/getCurrentFiltersCount';
import { getHitsPerPageConfiguration } from '~~/helpers/typesense/getHitsPerPage';
import { StringBoolean } from '~~/types/StringBoolean';
import {
  BOOLEAN_ATTRIBUTE_LABELS,
  CATEGORY_FILTER_INDICATOR,
  TRANSLATABLE_CURRENT_REFINEMENTS,
} from '~~/constants/typesense';
import { getTypesenseCategoryFilter } from '~~/helpers/category/getTypesenseCategoryFilter';

export const useTypesense = () => {

  const i18n = useI18n();
  const route = useRoute();
  const { isCampaignLabel } = useStoreVsfExtended();
  const { getCampaignLabel } = useCampaignTag();

  const isFiltering = (indexName: string, renderState: any): boolean => {

    return getCurrentFiltersCount(indexName, renderState) > 0;

  };

  const mainSearchIndex: ComputedRef<string> = computed(() => {

    return i18nToTypesenseMainIndex(i18n);

  });

  const hitsPerPageConfiguration = computed(() => {

    return route.query && getHitsPerPageConfiguration(route.query);

  });

  const getTypesenseFilterName = (
    filterRawLabel: string,
    filterAttribute: Maybe<string> = null,
  ): string => {

    if (filterRawLabel === StringBoolean.true) {

      if (filterAttribute) {

        return i18n.t(BOOLEAN_ATTRIBUTE_LABELS.INCLUSIVE.LONG, { attribute: filterAttribute });

      } else {

        return i18n.t(BOOLEAN_ATTRIBUTE_LABELS.INCLUSIVE.SHORT);

      }

    } else if (filterRawLabel === StringBoolean.false) {

      if (filterAttribute) {

        return i18n.t(BOOLEAN_ATTRIBUTE_LABELS.EXCLUSIVE.LONG, { attribute: filterAttribute });

      } else {

        return i18n.t(BOOLEAN_ATTRIBUTE_LABELS.EXCLUSIVE.SHORT);

      }

    } else if (TRANSLATABLE_CURRENT_REFINEMENTS.includes(filterRawLabel)) {

      return i18n.t(filterRawLabel);

    } else if (isCampaignLabel(filterRawLabel)) {

      return getCampaignLabel(filterRawLabel);

    } else if (filterRawLabel.includes(CATEGORY_FILTER_INDICATOR)) {

      return filterRawLabel.split(CATEGORY_FILTER_INDICATOR).pop() || '';

    } else {

      return filterRawLabel;

    }

  };

  return {
    hitsPerPageConfiguration,
    isFiltering,
    mainSearchIndex,
    getTypesenseCategoryFilter,
    getTypesenseFilterName,
  };

};
